"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var htmlparser2 = __importStar(require("htmlparser2"));
/**
 * Fix various problems in input HTML before it can be parsed by cheerio.
 */
function fixBrokenHtml(inputHtml) {
    var fixedHead = fixBrokenHead(inputHtml);
    return fixedHead;
}
function fixBrokenHead(inputHtml) {
    var encounteredTags = new Set();
    var isBroken = false;
    var headStartIndex;
    var parserDetect = new htmlparser2.Parser({
        onopentag: function (name) {
            if (name === 'head') {
                headStartIndex = parserDetect.startIndex;
            }
            encounteredTags.add(name);
            var htmlTag = encounteredTags.has('html');
            var headTag = encounteredTags.has('head');
            var blockquoteTag = encounteredTags.has('blockquote');
            // If there's a blockquote before the head tag, this is likely a quoted message
            if (!htmlTag && headTag && !blockquoteTag) {
                isBroken = true;
                parserDetect.reset(); // abort parsing
            }
            else if (htmlTag) {
                isBroken = false;
                parserDetect.reset(); // abort parsing
            }
        },
    });
    parserDetect.write(inputHtml);
    parserDetect.end();
    if (!isBroken) {
        return inputHtml;
    }
    // Remove everything before head, and wrap in html
    var fixedHtml = inputHtml.slice(headStartIndex);
    fixedHtml = "<html>" + fixedHtml + "</html>";
    return fixedHtml;
}
exports.default = fixBrokenHtml;
